import { AutogenLayoutCarrierAssignmentPrompt } from "./autogen/AutogenLayoutCarrierAssignmentPrompt";

export class CarrierAssignmentPrompt extends AutogenLayoutCarrierAssignmentPrompt {
}
